import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {Template} from '../../../shared/interface/template';
import {TemplateService} from '../../../shared/services/template.service';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {AuthService} from '../../../shared/services/auth.service';
import {
  FILE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE,
  TEMPLATE_TYPE_ANNEX_COMMISSION_ATTACHMENT,
  TEMPLATE_TYPE_ANNEX_OFWCA_APPLICATION,
  TEMPLATE_TYPE_AUTHORIZATION,
  TEMPLATE_TYPE_CONTRACT,
  TEMPLATE_TYPE_OFWCA_APPLICATION,
  TEMPLATE_TYPE_PARTNER_DATA,
  TEMPLATE_TYPE_STATEMENT,
  TEMPLATE_TYPE_CONTRACT_WITH_EMPLOYEE,
  TEMPLATE_TYPE_TERMINATION,
  TEMPLATE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE,
  TEMPLATE_TYPE_DISTRIBUTOR_INFORMATION,
  TEMPLATE_TYPE_AGENT_POWER_OF_ATTORNEY,
  TEMPLATE_TYPE_DECLARATION_FOR_DEREGISTRATION,
  TEMPLATE_TYPE_ANNEX_LEAD_TEMPLATE,
  TEMPLATE_TYPE_ANNEX_AUTOMATIC_BILLING,
  TEMPLATE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE_AND_AUTOMATIC_BILLING, IS_PUBLIC_AGENT_INFORMATION_DOCUMENT,
  TEMPLATE_TYPE_INFORMATION_ABOUT_RODO, TEMPLATE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE_WITHOUT_AUTOMATIC_BILLING
} from '../../../shared/services/dict.service';
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-template-details-view',
  templateUrl: './template-details-view.component.html',
  styleUrls: ['./template-details-view.component.scss']
})
export class TemplateDetailsViewComponent implements OnInit, OnDestroy {
  @Input() template: Observable<Template>;
  @Output() modifyClicked = new EventEmitter<any>();

  templateObject?: Template;
  userPermissions: ReplaySubject<UserPermissions>;

  readonly TEMPLATE_TYPE_CONTRACT = TEMPLATE_TYPE_CONTRACT;
  readonly TEMPLATE_TYPE_TERMINATION = TEMPLATE_TYPE_TERMINATION;
  readonly TEMPLATE_TYPE_STATEMENT = TEMPLATE_TYPE_STATEMENT;
  readonly TEMPLATE_TYPE_AUTHORIZATION = TEMPLATE_TYPE_AUTHORIZATION;
  readonly TEMPLATE_TYPE_PARTNER_DATA = TEMPLATE_TYPE_PARTNER_DATA;
  readonly TEMPLATE_TYPE_OFWCA_APPLICATION = TEMPLATE_TYPE_OFWCA_APPLICATION;
  readonly TEMPLATE_TYPE_ANNEX_OFWCA_APPLICATION = TEMPLATE_TYPE_ANNEX_OFWCA_APPLICATION;
  readonly TEMPLATE_TYPE_ANNEX_COMMISSION_ATTACHMENT = TEMPLATE_TYPE_ANNEX_COMMISSION_ATTACHMENT;
  readonly TEMPLATE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE = TEMPLATE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE;
  readonly TEMPLATE_TYPE_CONTRACT_WITH_EMPLOYEE = TEMPLATE_TYPE_CONTRACT_WITH_EMPLOYEE;
  readonly TEMPLATE_TYPE_DISTRIBUTOR_INFORMATION = TEMPLATE_TYPE_DISTRIBUTOR_INFORMATION;
  readonly TEMPLATE_TYPE_AGENT_POWER_OF_ATTORNEY = TEMPLATE_TYPE_AGENT_POWER_OF_ATTORNEY;
  readonly TEMPLATE_TYPE_DECLARATION_FOR_DEREGISTRATION = TEMPLATE_TYPE_DECLARATION_FOR_DEREGISTRATION;
  readonly TEMPLATE_TYPE_ANNEX_LEAD_TEMPLATE = TEMPLATE_TYPE_ANNEX_LEAD_TEMPLATE;
  readonly TEMPLATE_TYPE_ANNEX_AUTOMATIC_BILLING = TEMPLATE_TYPE_ANNEX_AUTOMATIC_BILLING;
  readonly TEMPLATE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE_AND_AUTOMATIC_BILLING = TEMPLATE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE_AND_AUTOMATIC_BILLING;
  readonly TEMPLATE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE_WITHOUT_AUTOMATIC_BILLING = TEMPLATE_TYPE_ANNEX_NEW_CONTRACT_TEMPLATE_WITHOUT_AUTOMATIC_BILLING;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private templateService: TemplateService,
    private auth: AuthService,
  ) {
    this.userPermissions = auth.getUserPermissions();
  }

  ngOnInit(): void {
    this.template
      .pipe(takeUntil(this.destroyed$))
      .subscribe((template: Template) => this.templateObject = template);
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  modify(): void {
    this.modifyClicked.emit();
  }

  download(): void {
    this.templateService.downloadFile(this.templateObject.uuid);
  }

  publicLink(link: string){
    return environment.apkUrl + '/public' + link;
  }

  readonly TEMPLATE_TYPE_INFORMATION_ABOUT_RODO = TEMPLATE_TYPE_INFORMATION_ABOUT_RODO;
}
